import filter from "lodash-es/filter"

import renderers from "./session-info.renderers.messages"
import type {
    _TSessionInfoMessageComponentProps as TMessageBusProps,
    _TSessionInfoRenderFunctionSharedExternalParams as TRenderMessageBusFunctionExternalParams,
    _TSessionInfoRenderMessagesPropsFunctionInternalParams as TRenderMessageBusFunctionInternalParams
} from "./session-info.types"

export default function (
    internal: TRenderMessageBusFunctionInternalParams,
    external: TRenderMessageBusFunctionExternalParams
): TMessageBusProps[] {
    return filter<TMessageBusProps>(
        [
            Boolean(internal.isAccordionExpandable && internal.session.isExtraParty) &&
                renderers.renderSessionTypeMessageProps({ ...internal, ...external }),

            Boolean(internal.isAccordionExpandable && internal.session.rescheduleCount > 0) &&
                renderers.renderRescheduleCountMessageProps({ ...internal, ...external })
        ],
        Boolean
    )
}
